import * as React from 'react';
import { observer } from 'mobx-react';

import Reference from 'shared/newComponents/Reference';
import Status from 'shared/newComponents/Status';
import { StatusType } from 'shared/newEntities/components/Status';
import { Button } from 'shared/newComponents/buttons';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';
import { ComponentType } from 'shared/entities/components/Component';
import { useTypedTranslation } from 'shared/entities/localization';
import { IWidgetChannelModel } from 'shared/entities/channels';
import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType
} from 'shared/newEntities/components/Typography';

import './WidgetInstallWarningStatus.modules.scss';

type Props = {
  channel: IWidgetChannelModel;
};

const WidgetInstallWarningStatus: React.FC<Props> = ({ channel }) => {
  const { t } = useTypedTranslation('newContainers');

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      channel.checkInstall();
    },
    [channel]
  );

  return (
    <Reference
      trigger={
        <div>
          <Status type={StatusType.warning} />
        </div>
      }
      title={(t) =>
        t('ChannelsModal.ChannelTable.WidgetInstallCheckReference.title', {
          ns: 'newContainers'
        })
      }
      description={
        <div styleName="widget-install-status__description">
          <Typography
            fontType={TypographyType.text}
            fontSize={TypographySize.xs}
            fontColor={TypographyColor.secondary}
          >
            {t(
              'ChannelsModal.ChannelTable.WidgetInstallCheckReference.description',
              {
                ns: 'newContainers'
              }
            )}
          </Typography>
          <div styleName="widget-install-status__button-container">
            <Button
              styleName="widget-install-status__button"
              type={ComponentType.button}
              onClick={handleClick}
              disabled={channel.isInstallCheckBlocked}
              color={ButtonColor.lightBlue}
              isLoading={channel.isChecking}
              size={ButtonSize.xs}
              withoutBorder
            >
              {t('ChannelsModal.ChannelForm.Widget.Install.button', {
                ns: 'newContainers'
              })}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default observer(WidgetInstallWarningStatus);
